import React from "react";
import Subscriber from "../../../subscriber.class";
import Storage from "../../../services/storage.service";
import Flow from "../../../services/flow.service";
import Translations from "../../../services/translation";
import MapContainer from "../../../Modules/SimDelivery/MapContainer";
// import Forms from "../../../services/forms.service";
export default class SummaryAddress extends Subscriber {
  savedAddress;
  componentDidMount() {
   
  }

  parse_delivery_address = (address) => {
    var final_address = "";
    if(address){
      final_address += address;
    }
    if(address && address.address_2 && address.address_2.value){
      final_address += ', ' + address.address_2.value;
    }
    if(address && address.instructions && address.instructions.value){
      final_address += ', ' + address.instructions.value;
    }
    // add phone number to address string: 
    let phone = JSON.parse(Storage.get("delivery_form"))?.phone?.value;
    if(phone){
      final_address=final_address+' - '+phone; 
    }
    final_address = final_address.toString().split('-');
    return final_address.map((item, i)=>(<p key={item}>{item} {i !== final_address.length-1? '-':''}</p>));
  }
  penAction = () => {
    // Forms.inputChangedHandler("delivery", "", "location_type")

    Storage.clear("addressLatLang");
    Storage.clear("location_type");
    Storage.clear("addressLocation");
    Storage.clear("address_emirate");
    Storage.clear("delivery_form");
    Storage.clear("locationIsPicked");
    Storage.set("addressStepNumber", 1, true)
    Flow.goToStepBase("delivery");
  }
  render() {
    let strings = Translations["keys"][Translations.activeLang];
    // let address = SIM.getSubmittedAddress();
    let pen = (
      <div
        className="vmo-summary-edit"
        onClick={() => this.penAction()}
      />
    );

    if (this.props.delivery_address) {
      return (
        <div className="vmo-summary-section map-summary-section">
          <div className="vmo-summary-box-wrapper">
            <div className="vmo-summary-box">
              <div className="vmo-summary-section-header">
                  <h3> {strings["PAYMENT_SUMMARY_ADDRESS_BOX_TITLE"]} </h3>
                  <div className="vmo-summary-address">
                    {this.props.delivery_address !== undefined ? this.parse_delivery_address(this.props.delivery_address) :
                    this.parse_delivery_address(this.props.savedAddress)  }
                  </div>
                  {pen}
                    <div className="vmo-summary-map">
                        <MapContainer
                          id={"delivery"}
                          disable_search={true}
                          freeze={true}
                        />
                  </div>
              </div>
            </div>
          </div>
        </div>
      );
    }

    return "";
  }
}
